export default __webpack_public_path__ + "static/create-cohort-from-trend-dark-mode-025c667f8942bbd955e2a290586d9c03.mp4";